import HBInputNumber from "@/components/HBInputNumber";
import { EVENT } from "@/constants/event";
import { PIN_OPEN_TYPE, PIN_OPEN_TYPE_LIST } from "@/constants/pinOpenType";
import { TRANSPARENT_IMG_BG_LIST } from "@/constants/transparentImgBg";
import useAppStore from "@/context/store";
import { savePageSetting } from "@/services";
import { safeParse } from "@/utils/safeParse";
import useRequest from "@/utils/useReq";
import { Radio } from "antd";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { Case, Default, Else, If, Switch, Then, When } from "react-if";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

function BackgroundRadioGroup({ value, onChange }) {
  const onSelect = useCallback(
    (item) => {
      onChange(item);
    },
    [onChange]
  );

  return (
    <div className={styles.radio}>
      {TRANSPARENT_IMG_BG_LIST.map((item) => (
        <div
          className={classNames([
            styles.option,
            styles[item.value],
            value === item.value ? styles.active : null,
          ])}
          key={item.value}
          onClick={() => onSelect(item.value)}
        ></div>
      ))}
    </div>
  );
}

export function PageSetting() {
  const [index, setIndex] = useState(0);
  const user = useAppStore((s) => s.user);
  const [params, setParams] = useState({
    columnType: "full",
    limit: 4,
    imageBackground: "grid-bg",
  });

  useEffect(() => {
    const params = safeParse(
      window.localStorage.getItem("huaban-page-setting")
    );
    if (params) {
      setParams(params);
    }
  }, []);

  const { run: runSavePageSetting } = useRequest(savePageSetting, {
    debounceWait: 500,
    manual: true,
  });

  useEffect(() => {
    window.dispatchEvent(new Event(EVENT.PAGE_SETTING_CHANGE));
  }, [params]);

  const onLimit = useCallback(
    (value) => {
      const limit = value || 4;
      setParams((params) => {
        const newParams = {
          ...params,
          limit,
        };
        window.localStorage.setItem(
          "huaban-page-setting",
          JSON.stringify(newParams)
        );
        if (user) {
          runSavePageSetting(newParams);
        }
        return newParams;
      });
    },
    [runSavePageSetting, setParams, user]
  );

  const onColumnType = useCallback(
    (evt) => {
      setParams((params) => {
        const width = Math.max(window.innerWidth, 1120);
        const paddingWidth = 42;
        const itemWidth = 240;
        const itemGap = 24;
        const limit = Math.floor(
          (width - paddingWidth * 2 + itemGap) / (itemWidth + itemGap)
        );
        const newParams = {
          ...params,
          columnType: evt.target.value,
          limit,
        };
        window.localStorage.setItem(
          "huaban-page-setting",
          JSON.stringify(newParams)
        );
        if (user) {
          runSavePageSetting(newParams);
        }
        return newParams;
      });
    },
    [runSavePageSetting, setParams, user]
  );

  const onImageBackground = useCallback(
    (value) => {
      setParams((params) => {
        const newParams = {
          ...params,
          imageBackground: value,
        };
        window.localStorage.setItem(
          "huaban-page-setting",
          JSON.stringify(newParams)
        );
        if (user) {
          runSavePageSetting(newParams);
        }
        return newParams;
      });
    },
    [runSavePageSetting, setParams, user]
  );

  const onPinOpenTypeChange = useCallback(
    (evt) => {
      setParams(() => {
        const newParams = {
          ...params,
          pinOpenType: evt.target.value,
        };
        window.localStorage.setItem(
          "huaban-page-setting",
          JSON.stringify(newParams)
        );
        if (user) {
          runSavePageSetting(newParams);
        }
        return newParams;
      });
    },
    [params, runSavePageSetting, setParams, user]
  );

  const onHover = useCallback((index) => {
    setIndex(index);
  }, []);

  return (
    <div className={styles.preference}>
      <div className={styles.container}>
        <div className={styles.list}>
          <div className={styles.bg} style={{ top: `${index * 91}px` }}></div>
          <div className={styles.item} onMouseEnter={() => onHover(0)}>
            <div className={styles.main}>
              <div className={styles.title}>信息流显示列数</div>
              <div className={styles.action}>
                <Radio.Group
                  size="small"
                  value={params.columnType}
                  onChange={onColumnType}
                >
                  <Radio value="full">自适应屏幕</Radio>
                  <Radio value="limit">自定义</Radio>
                </Radio.Group>
              </div>
            </div>
            <When condition={params.columnType === "limit"}>
              <div className={styles.sub}>
                <div className={styles.title}>最大列数</div>
                <div className={styles.action}>
                  <HBInputNumber
                    max={20}
                    min={4}
                    value={params.limit}
                    onChange={onLimit}
                  />
                </div>
              </div>
            </When>
          </div>
          <div className={styles.item} onMouseEnter={() => onHover(1)}>
            <div className={styles.main}>
              <div className={styles.title}>PNG默认背景</div>
              <div className={styles.action}>
                <BackgroundRadioGroup
                  value={params.imageBackground}
                  onChange={onImageBackground}
                />
              </div>
            </div>
          </div>
          <div className={styles.item} onMouseEnter={() => onHover(2)}>
            <div className={styles.main}>
              <div className={styles.title}>采集打开方式</div>
              <div className={styles.action}>
                <Radio.Group
                  size="small"
                  value={params.pinOpenType || PIN_OPEN_TYPE.MODAL}
                  onChange={onPinOpenTypeChange}
                  options={PIN_OPEN_TYPE_LIST}
                ></Radio.Group>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.preview}>
          <Switch>
            <Case condition={index === 0}>
              <div className={styles.browser}>
                <img
                  className={styles.content}
                  src="//cdn.dancf.com/fe-assets/20230906/6aea0bf88b585fd61ce8a058de143c8e.png"
                  alt="浏览器"
                />
                <Switch>
                  <Case
                    condition={
                      params.columnType === "limit" && params.limit === 4
                    }
                  >
                    <img
                      className={styles.column}
                      src="//cdn.dancf.com/fe-assets/20230906/8faf8a25efa10457cdb6eebd68479a63.png"
                      alt="4列"
                    />
                  </Case>
                  <Case
                    condition={
                      params.columnType === "limit" && params.limit === 5
                    }
                  >
                    <img
                      className={styles.column}
                      src="//cdn.dancf.com/fe-assets/20230906/7e415ba188babbff193d5146b19fe37d.png"
                      alt="5列"
                    />
                  </Case>
                  <Case
                    condition={
                      params.columnType === "limit" && params.limit === 6
                    }
                  >
                    <img
                      className={styles.column}
                      src="//cdn.dancf.com/fe-assets/20230906/58784d4aaa7ca4af3106dd90cb97d4c5.png"
                      alt="6列"
                    />
                  </Case>
                  <Default>
                    <img
                      className={styles.column}
                      src="//cdn.dancf.com/fe-assets/20230906/8d90ce70cfb726603eb0db2a40394fa2.png"
                      alt="7列"
                    />
                  </Default>
                </Switch>
                <div className={styles.text}>当前预览以1920*1080为例</div>
              </div>
            </Case>
            <Case condition={index === 1}>
              <div className={styles.bg}>
                <img
                  className="transparent-img-bg"
                  src="//cdn.dancf.com/fe-assets/20230906/765bd10d7c3937e496e70494e598579f.png"
                  alt="logo"
                />
              </div>
            </Case>
            <Case condition={index === 2}>
              <If condition={params.pinOpenType === PIN_OPEN_TYPE.BLANK}>
                <Then>
                  <div className={styles.img}>
                    <img
                      src="//cdn.dancf.com/fe-assets/20230906/c82ffd171a783d62b917a1204602463f.gif"
                      alt="新开窗口"
                    />
                  </div>
                </Then>
                <Else>
                  <div className={styles.img}>
                    <img
                      src="//cdn.dancf.com/fe-assets/20230906/ca07554795d69eed39008d77bc13b734.gif"
                      alt="当前页面"
                    />
                  </div>
                </Else>
              </If>
            </Case>
          </Switch>
        </div>
      </div>
    </div>
  );
}

function PageSettingModal(props) {
  return (
    <HBModal
      wrapClassName={styles.modal}
      title="偏好设置"
      width={760}
      destroyOnClose={true}
      footer={null}
      {...props}
    >
      <PageSetting />
    </HBModal>
  );
}

export default ModalWrap(PageSettingModal);
